"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_2_buff = _interopRequireDefault(require("../images/help_2_buff.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bupWindow = {
  id: "bupWindow",
  title: {
    en: "bup window",
    de: "Buff-Fenster"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_2_buff.default,
      alt: "",
      style: {
        width: "390px",
        height: "21px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "bup window"), /*#__PURE__*/_react.default.createElement("p", null, "Bup window is separated into blessed bup and curse bup windows."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Blessed bup window"), /*#__PURE__*/_react.default.createElement("p", null, ":Magic that are good for you are on the top left screen in order."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Curse bup window"), /*#__PURE__*/_react.default.createElement("p", null, ":Any magic that are bad for you will be top right screen"), /*#__PURE__*/_react.default.createElement("p", null, "Take your mouse to the Bup window and you will see bup content will be shown.", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "There are total of 10 bup individual windows."), /*#__PURE__*/_react.default.createElement("li", null, "Same type of bup can change for best result."), /*#__PURE__*/_react.default.createElement("li", null, "If the time runs out then the icon will blink and then will disappear."))))
  }
};
var _default = bupWindow;
exports.default = _default;